import React, {Component} from 'react'
import PrintPreview from '../PrintPreview'
import PdfStore from 'stores/PdfStore'
import { momentHelper } from '../../report/helpers'
import FontAwesome from 'react-fontawesome'

const month = momentHelper.getMonth()
const year = momentHelper.getYear()
const day = momentHelper.getDay()
const DEFAULT_ROW = 5
class PrintSSTBillingNoteInsurer extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:{},dataList:[],report_title:'กำลังดึงข้อมูล..'}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData()
  }

  loadData() {
    let {data,dataList} = this.state
    let {ivList,bn} = this.props
    let docNo = ivList!==undefined?ivList:bn!==undefined?bn:ivList
    let sn = ivList!==undefined?'ivlist':bn!==undefined?'bn':'ivlist'
    PdfStore.loadBillingNoteDoc(sn,docNo,(result) => {
      data = result.data
      dataList = this.getPagination(result.data.list)
      this.setState({data:data,dataList:dataList,report_title:'ไม่พบข้อมูล'})
    })
  }

  renderSignature() {
    return(
      <table className='table table-header-print-kkc-billing-note'>
        <tbody>
          <tr>
            <td className='text-center'>ลงชื่อ..............................ผู้วางบิล</td>
            <td className='text-center'>ลงชื่อ..............................ผู้รับวางบิล</td>
            <td className='text-center'>ลงชื่อ..............................ผู้รับเอกสาร</td>
            <td className='text-center'>ลงชื่อ..............................ผู้บันทึก</td>
          </tr>
          <tr>
            <td className='text-center'>{'วันที่ '+day+'/'+month+'/'+year}</td>
            <td className='text-center'>วันที่........./........./.........</td>
            <td className='text-center'>วันที่........./........./.........</td>
            <td className='text-center'>วันที่........./........./.........</td>
          </tr>
        </tbody>
      </table>
    )  
  }

  renderHeader() {
    let {data} = this.state
    return(
      <table className='table table-header-print-kkc-billing-note' style={{marginBottom:'0'}}>
        <tbody>
          <tr>
            <td style={{width:'10%'}}>เลขที่</td>
            <td style={{width:'70%'}}></td>
            <td style={{width:'20%'}} className='text-right'>วันที่ {data.billingnote_date}</td>
          </tr>
          <tr>
            <td>ชื่อเจ้าของรถ</td>
            <td>{data.customer!==undefined?data.customer.customer_name:''}</td>
            <td className='text-right'>{data.billingnote_no!==''&&data.billingnote_no!==null&&data.billingnote_no!==undefined?'เลขที่ใบวางบิล '+data.billingnote_no:''}</td>
          </tr>
          <tr>
            <td>ที่อยู่</td>
            <td colSpan={2}>{data.customer!==undefined?data.customer.customer_address:''}</td>
          </tr>
          <tr>
            <td colSpan={3} className='text-center'>ขอนำส่งเอกสารเพื่อขอเบิกค่าซ่อม ตามรายการดังต่อไปนี้</td>
          </tr>
        </tbody>
      </table>
    )
  }

  renderRowData(item) {
    if (item.length==0) {
      return(
        <tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>
      )
    } else {
      return(
        item.map((item,index) => {
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center font-print-14 font-12'>{item.work_no}</td>
              <td className='text-center font-print-14 font-12'>{item.claim_no}</td>
              <td className='text-center font-print-14 font-12'>{item.insurance_policy_no}</td>
              <td className='text-center font-print-14'>{item.car_registration_no}</td>
              <td className='text-center font-print-14'>{item.opposite_car}</td>
              <td className='text-center'>{item.invoice_no}</td>
              <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
            </tr>
          )
        })  
      )    
    }      
  }

  renderTable(item) {
     return(
      <div className=''>
        <table className='table table-responsive table-hover table-bordered-solid table-print-kkc-billing-note'>
          <thead>
            <tr>
              <th className='text-center bg-none' rowSpan={2} style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center bg-none' rowSpan={2} style={{width:'80px'}}>เลขที่ใบงาน</th>
              <th className='text-center bg-none' rowSpan={2} style={{width:'80px'}}>เลขที่เคลม</th>
              <th className='text-center bg-none' rowSpan={2} style={{width:'80px'}}>เลขกรมธรรม์</th>
              <th className='text-center bg-none' colSpan={2}>ทะเบียน</th>
              <th className='text-center bg-none' rowSpan={2} style={{width:'80px'}}>เลขที่<br/>ใบเสร็จรับเงิน</th>
              <th className='text-center bg-none'>จำนวนเงิน</th>              
            </tr>
            <tr>
              <th className='text-center bg-none' style={{width:'130px'}}>รถประกัน</th>
              <th className='text-center bg-none' style={{width:'130px'}}>รถคู่กรณี</th>
              <th className='text-center bg-none' style={{width:'80px'}}>บาท</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData(item)}
          </tbody>
          <tfoot>
            <tr>
              <th className='text-center bg-none' colSpan={7}>รวมทั้งสิ้น</th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary())}</th>              
            </tr>
          </tfoot>
        </table>
      </div>
    )      
  }

  getNumberFormat(val) {
    if (val!==''&&val!==null&&val!==undefined&&!isNaN(val)) {
      return parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    return ''
  }

  getSummary() {
    let {data} = this.state
    let sum = 0
    data.list.forEach(function(item,index) {
      let amount = item.amount
      if (amount===''||amount===null||amount===undefined||isNaN(amount))
        amount = 0

      sum += parseFloat(amount)
    })
    return sum
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  renderCompany(index) {
    let {data} = this.state
    return(
      [ 
        <header key={'h-'+index}>
          <h2>{this.props.title}</h2>
        </header>,
        <article className={"article-company "+data.logo_class} key={'a-'+index}>
          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(data.logo_url)}
          </div>
          <section className="font-18" style={{width:'85%',paddingTop:(data.logo_class=='bg-logo-absolute'?'0':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร {data.company_tel} โทรสาร {data.company_fax}</p>             
            </strong>
          </section>
          <section className='text-right sec-copy-doc'>
            <span>{index==0?'ต้นฉบับ':'สำเนา'}</span>  
          </section>
        </article>
      ]
    )
  }

  renderAll(item) {
    return(
      item.list.map((sub_item,index) => {
        return(
          <div key={index}>
            {this.renderCompany(index)}
            <div className='font-14'>   
              {this.renderHeader()}
              {this.renderTable(sub_item)}
              {this.renderSignature()}
            </div>
            <div style={{width:'100%',display:item.list.length>1&&item.list.length-1!==index?'':'none'}}>
              <div style={{width:'5%',float:'left'}}>
                <FontAwesome name='scissors' className='scissors-insurer' />
              </div>
              <div style={{width:'95%',float:'right'}}>
                <hr className='hr-billing-note-insurer' />
              </div> 
            </div>
          </div>
        )
      })
    )  
  }

  renderComponentPage(item,index,total) {
    return(
      <div className='font-print' key={index}>
        {this.renderAll(item)}  
      </div>  
    )
  }

  getPagination(data) {
    let allData = []
    let setData = []

    if (data.length<DEFAULT_ROW) {
      for (var i=data.length;i<DEFAULT_ROW;i++) {
        data.push({
          car_registration_no:'',
          invoice_no:'',
          amount:'',
          purchase_order_no:'',
          work_no:'',
          claim_no:'',
          insurance_policy_no:'',
          quotation_no:'',
          opposite_car:''
        })
      }
    }

    if (data.length>DEFAULT_ROW) {
      setData.push(data)
      allData.push({
        list: setData,
        page: 1
      })
      allData.push({
        list: setData,
        page: 2
      })
    } else {
      setData.push(data)
      setData.push(data)
      allData.push({
        list: setData,
        page: 1
      })
    }

    return allData
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading,dataList} = this.state
    if (dataList.length===0) {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
        >
          {this.renderNoData()}
        </PrintPreview>
      )  
    } else {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
        >
          {
            dataList.map((item,index) => {
              return(
                this.renderComponentPage(item,index,dataList.length)
              )
            })
          }
        </PrintPreview>
      )
    }  
  }

}  

PrintSSTBillingNoteInsurer.defaultProps = {
  title: 'ใบวางบิล',  
  mode : '1'
}
export default PrintSSTBillingNoteInsurer;


// WEBPACK FOOTER //
// ./src/view/print/sst/PrintSSTBillingNoteInsurer.js